
import AppConfig from '../appConfig'
import axios from "axios";
import store from '../store/store'
const axiosins = axios.create({
    baseURL: AppConfig.API.BASE_URL_V3,
    timeout:15000
})
let setCookie = (c_name, value, expiredays) => {
  let exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) + ";path=/"
    // + (AppConfig.API.DOMAIN_NAME ? ";domain=" + AppConfig.API.DOMAIN_NAME : "")
    + ((expiredays === null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
}

let delCookie = (name) => {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval !== null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}
//获取Cookie
let getCookie = (name) => {
  let arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if (arr = document.cookie.match(reg)) {
    return (arr[2])
  } else {
    return null
  }
}
// 添加请求拦截器
axiosins.interceptors.request.use(function (config) {
    //从localstorage中拿出token 放到请求头中
    let token = store.state.token ? store.state.token : ''
    if (!token) {
      token = getCookie('token')
      if (token) {
        token = unescape(token)
      }
    }
    if(token){
        config.headers["token"] = token
    }
    return config;
});

// 添加响应拦截器
axiosins.interceptors.response.use(function (response) {

    if (Number(response.data.code) === 20300) {
      //登录已失效，清除用户信息
      delCookie('token');
      delCookie('userInfo');
      store.commit('updateUserInfo', "");
      store.commit('updateToken', "");
      store.commit('updateCompany', "")
      store.commit('updateCompanyId', "")

      // console.log(url)
      // 跳转登录页
      let redirect = window.location.href
      window.location.href = AppConfig.API.MOBILE_V3 + '/login?redirect=' + redirect
    }

    return response.data;
}, function (error) {
    return Promise.reject(error);
});


export default axiosins;



// WEBPACK FOOTER //
// ./src/factory-api/ApiServer.js